<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">Create Schedule Process</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="processForm" class="col-12">
            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Select Payroll</mat-label>
                    <input type="text" matInput [formControl]="payrollCtrl" [matAutocomplete]="autoPayroll" required>
                    <mat-autocomplete #autoPayroll="matAutocomplete"
                        (optionSelected)="onPayrollSelected($event.option.value)">
                        <!-- <mat-option [value]="''">-- None --</mat-option> -->
                        <mat-option *ngFor="let payroll of filteredPayrolls | async" [value]="payroll.payrollType">
                            {{ payroll.payrollType }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Select Period</mat-label>
                    <input type="text" matInput [formControl]="periodCtrl" [matAutocomplete]="autoPeriod" required>
                    <mat-autocomplete #autoPeriod="matAutocomplete"
                        (optionSelected)="onPeriodSelected($event.option.value)">
                        <!-- <mat-option [value]="''">-- None --</mat-option> -->
                        <mat-option *ngFor="let period of filteredPeriods | async" [value]="period.payrollName">
                            {{ period.payrollName }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="col-6 custom-datetime-field">
                    <mat-label>Account Date</mat-label>
                    <input matInput type="date" formControlName="selectedDate" required />
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                </mat-form-field>
            </div>
            <!-- <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Schedule</mat-label>
                    <input type="text" matInput [formControl]="scheduleCtrl" [matAutocomplete]="autoSchedule" required>
                    <mat-autocomplete #autoSchedule="matAutocomplete"
                        (optionSelected)="onScheduleSelected($event.option.value)">
                        <mat-option *ngFor="let schedule of filteredSchedules | async" [value]="schedule.name">
                            {{ schedule.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix tabindex="-1">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-6 custom-datetime-field">
                    <mat-label>Start Date & Time</mat-label>
                    <input matInput type="datetime-local" formControlName="startDate" required />
                    <mat-hint>MM/DD/YYYY, HH:mm</mat-hint>
                </mat-form-field>
            </div> -->
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-0 text-right">
        <button mat-button class="cancel-button" (click)="onNoClick()">Cancel</button>
        <button *ngIf="!loading; else loadingTemplate" mat-button class="yes-button" cdkFocusInitial [disabled]="!processForm.valid"
            (click)="onSubmit()">Submit</button>
        <ng-template #loadingTemplate>
            <button mat-button class="yes-button" disabled>Submit&nbsp;
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>